import FontIcon from '@luminopia/react-toolbox/lib/font_icon'
import Input, {InputTheme} from '@luminopia/react-toolbox/lib/input'
import * as classnames from 'classnames'
import * as React from 'react'
import * as classNames from './styles.css'

export interface ITheme {
  container?: string
  inputContainer?: string
  inputTheme?: InputTheme
  iconContainer?: string
  icon?: string
}

export interface IProps {
  /** current search query */
  value?: string
  /** fires on input change */
  onChange?: (value: string) => void
  /** fires on clicking the clear icon */
  onClickClear?: () => void
  /** floating label for the input */
  label?: string
  /** component theme */
  theme?: ITheme
}

/**
 * A controlled search input with a clear search query button.
 * The user must implement the actual filtering based on search field value.
 */
class Search extends React.PureComponent<IProps, {}> {
  public render() {
    const theme: ITheme = this.props.theme || {}

    return (
      <div className={classnames(classNames.container, theme.container)}>
        <div className={classnames(classNames.inputContainer, theme.inputContainer)}>
          <Input
            type='text'
            value={this.props.value}
            onChange={this.props.onChange}
            label={this.props.label}
            icon='search'
            theme={theme.inputTheme}
          />
        </div>
        <div
          onClick={this.props.onClickClear}
          className={classnames(classNames.iconContainer, theme.iconContainer)}
        >
          <FontIcon className={classnames(classNames.icon, theme.icon)} value='clear'/>
        </div>
      </div>
    )
  }
}

export default Search



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/search/index.tsx